import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.059 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.76 5.68H.95V18h3.81zm0-3.32C4.74 1.02 3.84 0 2.4 0 .95 0 0 1.02 0 2.36c0 1.32.92 2.37 2.34 2.37h.03c1.48 0 2.4-1.05 2.4-2.37zm14.29 8.74c0-3.7-2-5.42-4.67-5.42-2.16 0-3.12 1.17-3.66 1.99V5.96H6.66c.05 1.13 0 12.04 0 12.04h4.06v-6.72c0-.36.02-.72.13-.98.3-.72.96-1.46 2.09-1.46 1.46 0 2.05 1.1 2.05 2.72V18h4.06z"
    }, null, -1)
  ]))]))
}
export default { render: render }